<template>
    <v-btn-toggle v-model="query['mode']" mandatory block color="primary" background-color="white" @change="emit">
        <template v-for="item in items">
            <v-btn :value="item.value" :key="item.value" text height="40">
                {{ item.text }}
            </v-btn>
        </template>
    </v-btn-toggle>
</template>

<script>
import { NSHOP_STATISTICS_MODES } from "@/store/nshop";

const items = Object.values(NSHOP_STATISTICS_MODES);
const mode_default = NSHOP_STATISTICS_MODES.DAILY.value;

const initQuery = (query = {}) => ({
    ...(query || {}),

    ["mode"]: query?.["mode"] || mode_default,
});

export default {
    components: {},
    data: () => ({
        query: initQuery(),
        items,
    }),
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query["page"];

            if (!query["mode"] || query["mode"] == mode_default) delete query["mode"];

            this.$router.push({ query });
        },
    },
    watch: {
        $route() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped></style>
